import { RiderStatus } from "@quickcommerceltd/zephyr-types";

export function isRiderWarehouseAssignable(riderStatus: RiderStatus) {
  return ["OFF_DUTY", "IDLE_AT_STORE", "RIDING_BACK_TO_STORE"].includes(
    riderStatus
  );
}
